import script from "./MediaflowMediaPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowMediaPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowMediaPreviewModal.vue?vue&type=style&index=0&id=066c09d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066c09d6"]])

export default __exports__